import { render, staticRenderFns } from "./12introduce.vue?vue&type=template&id=79c07742&scoped=true&"
import script from "./12introduce.vue?vue&type=script&lang=js&"
export * from "./12introduce.vue?vue&type=script&lang=js&"
import style0 from "./12introduce.vue?vue&type=style&index=0&id=79c07742&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c07742",
  null
  
)

export default component.exports